export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7889.b1c2b1a2.jpg";